<template>
  <CFormGroup wrapperClasses="input-group pt-2">
    <template #label>Customer</template>
    <template #input>
      <v-select
        class="w-100"
        :value="selectedCustomer"
        :label="'name'"
        :options="customerItems"
        placeholder="Search or select a customer"
        @input="handleCustomerSelect"
      >
        <template #no-options>
          No customers match.
        </template>
        <template #list-footer>
          <li class="border-top">
            <button
              type="button"
              class="btn btn-link btn-block text-left"
              @click="$emit('add-new-customer')"
            >
              <CIcon name="cil-plus" /> Add new customer
            </button>
          </li>
        </template>
      </v-select>
    </template>
  </CFormGroup>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "CustomerSelectComponent",
  components: {
    vSelect,
  },
  props: {
    selectedCustomer: {
      type: Object,
      default: null,
    },
    customerItems: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleCustomerSelect(selected) {
      this.$emit("customer-selected", selected);
    },
  },
};
</script>